import React from 'react';
import { Link } from 'react-router-dom';
import Brand from './Brand';

function Footer() {
  return (
    <footer className="site-footer">
      <div className="footer-grid">
        <div>
          <Brand light />
          <p>Vendor-neutral technology guidance for growing businesses in the NYC Tri-State area.</p>
        </div>
        <div>
          <h3>Solutions</h3>
          <Link to="/ucaas">UCaaS</Link>
          <Link to="/ccaas">CCaaS</Link>
          <Link to="/wireless">Business Wireless</Link>
          <Link to="/compare-providers">Compare Providers</Link>
        </div>
        <div>
          <h3>Company</h3>
          <Link to="/about">About</Link>
          <Link to="/resources">Resources</Link>
          <Link to="/faq">FAQ</Link>
          <Link to="/contact">Contact</Link>
        </div>
        <div>
          <h3>Start with clarity</h3>
          <p>No hard sell. Just a clear picture of your costs, gaps, and best next step.</p>
          <a className="button button-white" href="https://meet.cambiadigital.com/consult" target="_blank" rel="noopener noreferrer">Get Your Free Assessment</a>
        </div>
      </div>
      <div className="footer-bottom">
        <span>© 2025 Cambia Digital. All rights reserved.</span>
        <span>NYC Tri-State · Brooklyn · Queens</span>
      </div>
    </footer>
  );
}

export default Footer;